import type { User } from './User'
import type { Domains, Themes } from './Domains'
import type { AbstractCategory } from './Config'

export enum AbstractStatus {
  Draft = 'draft',
  Submitted = 'submitted',
  Published = 'published',
}

export enum AbstractType {
  ScienceThesis = 'science_thesis',
  MedicalThesis = 'medical_thesis',
  DesThesis = 'des_thesis',
  MasterThesis = 'master_thesis',
  '' = '',
}

export enum AbstractSource {
  ScholarshipPrize = 'scholarship_prize',
  Databases = 'databases',
  Other = 'other',
}

export enum AbstractSelectionStatus {
  ThematicSession = 'thematic_session',
  OralPresentation = 'oral_presentation',
  InteractivePoster = 'interactive_poster',
  DisplayPoster = 'display_poster',
  Rejected = 'rejected',
  Cancelled = 'cancelled',
  '' = '',
}

export enum AbstractRolesType {
  Speaker = 'speaker',
  Author = 'author',
  CoAuthor = 'co_author',
}

export interface Figures {
  id: number
  image: string
  title: string
}

export interface Authors {
  user: User
  roles: AbstractRolesType[]
}

export interface Departments {
  id: number
  name: string
  facility_id: number | null
}

export interface CoAuthors {
  id: number
  first_name: string
  last_name: string
  email: string
  department: number | null
  department_other: string
}

export type AdminAbstractDetails<IsAdmin extends boolean> = IsAdmin extends true
  ? {
      category: AbstractCategory
      selection_status: AbstractSelectionStatus
      session: number | null
      order: number | null
      number_of_ratings: number
      rating_average: number
      rating_stddev: number
      presentation_time: string | null
      qa_time: string | null
    }
  : object

export type Abstracts<IsAdmin extends boolean = false> = {
  id: number
  authors: Authors[]
  figures: Figures[]
  created?: string
  modified?: string
  type: AbstractType
  source: AbstractSource
  source_other?: string
  title: string
  objective: string
  materials_and_methods: string
  results: string
  conclusions: string
  title_en?: string
  objective_en?: string
  materials_and_methods_en?: string
  results_en?: string
  conclusions_en?: string
  status: AbstractStatus
  event: number
  domain: number
  theme: number
  department: Departments | null
  department_other: string
  owner: number
  keywords?: number[]
} & AdminAbstractDetails<IsAdmin>

export interface AbstractReviews {
  id: number
  created?: string
  modified?: string
  conflict_of_interest: string
  score: number | null
  proposed_topic_session: string
  comment: string
  abstract: number
  evaluator: number
}

export interface AbstractsStatistics {
  domain_stats: {
    domain: Domains
    count: number
  }[]
  theme_stats: {
    theme: Themes
    count: number
  }[]
  submitted_abstracts: number
  evaluators: number
  active_evaluators: number
  evaluations: number
}
